module.exports = __webpack_public_path__ + "img/media.8c5f2a3c.svg";